module.exports = __webpack_public_path__ + "static/media/LOGO.93b5757c.svg";